import React from 'react';

import { CampaignNameField } from '../fields';

export const Campaign = ({ platformName, generateNameAutomatically }) => (
  <CampaignNameField
    platformName={platformName}
    generateNameAutomatically={generateNameAutomatically}
  />
);
